import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * hallmark critique · CorridorPolyline
 * tokens locked from docs/design.md §1 (deep-ink stroke)
 * states covered: idle (static)
 * mobile verified: 320 / 375 / 414 / 768
 * no fake chrome · no italic headers · no shadows · single clay accent per viewport
 *
 * Two-stroke polyline for depth without shadows: a wide pebble halo below
 * and a thin deep-ink line on top. Reads as a drawn corridor — not a
 * network raster.
 */
import { Polyline } from "react-leaflet";
export function CorridorPolyline({ stops }) {
    const positions = stops.map((s) => [s.lat, s.lng]);
    return (_jsxs(_Fragment, { children: [_jsx(Polyline, { positions: positions, pathOptions: {
                    color: "#d5d3d4",
                    weight: 10,
                    opacity: 0.85,
                    lineCap: "butt",
                    lineJoin: "miter",
                } }), _jsx(Polyline, { positions: positions, pathOptions: {
                    color: "#000d10",
                    weight: 3,
                    opacity: 1,
                    lineCap: "butt",
                    lineJoin: "miter",
                } })] }));
}
